function layoutInit(){
	var body_container = $('.body-container'),
		header_container = $('.header-container'),
		footer_container = $('.footer-container'),
		content_container = $('.content-container'),
		panel_area = $('.panel-area'),
		content_area = $('.content-area'),
		lnb_area = $('.lnb-area'),
		middle_area = $('.middle-area'),
		top_area = $('.top-area');

	var panel_area_width = panel_area.outerWidth();

	// 넓이 높이 계산
	body_container.height($(window).height() - header_container.outerHeight() - footer_container.outerHeight());
	content_container.width(body_container.width() - panel_area_width);
	content_area.width(content_container.width() - lnb_area.width());
	middle_area.height(content_area.height() - top_area.outerHeight());

	// 리사이즈
	$(window).on('resize.divider', function(){
		body_container.height($(window).height() - header_container.outerHeight() - footer_container.outerHeight());
		content_container.width(body_container.width() - panel_area_width);
		content_area.width(content_container.width() - lnb_area.width());
		middle_area.height(content_area.height() - top_area.outerHeight());
	});

	/* 패널 디바이더 */
	// 핸들 있을경우 삭제
	if($('.panel-area').find('.ui-resizable-handle').length > 0){
		$('.panel-area').find('.ui-resizable-handle').remove();
	}
	$('.panel-area').resizable({
		handles: 'w',
		minWidth: 25,
		maxWidth: 300,
		resize: function(e, ui){
			ui.element.css({
				'left' : 'auto',
				'right' : 0
			});
			
			$('#js-iframe-cover').show().css({
				width:$(window).width(),
				height:$(window).height()
			});
		},
		stop:function(){
			$('#js-iframe-cover').hide();
		}
	});
	
	/* 왼쪽메뉴 디바이더 */
	// 핸들 있을경우 삭제
    
	if($('.lnb-area').find('.ui-resizable-handle').length > 0){
		$('.lnb-area').find('.ui-resizable-handle').remove();
	}
	$('.lnb-area').resizable({
		handles: 'e',
		minWidth: 31,
		maxWidth : 500,
		resize: function(e, ui){
			var parent = ui.element.parent();
			var remainingSpace = parent.width() - ui.element.outerWidth();

			var divTwo = ui.element.next(),
			divTwoWidth = (remainingSpace - (divTwo.outerWidth() - divTwo.width()));
			divTwo.width(divTwoWidth);

			// 일정 영역으로 줄었을때 최소값으로 변경 (추후 변경)
			if(ui.element.width() <= 60){
				console.log(ui.element.width());
				ui.element.width(31);
				ui.element.next().width(parent.width() - 31);
				$('.lnb-area').addClass('tiny');
				$('.lnb-area .lnb-head-btn .close').addClass('open').removeClass('close');
			} else {
				$('.lnb-area').removeClass('tiny');
				$('.lnb-area .lnb-head-btn .open').addClass('close').removeClass('open');
			}

		}
	});
	
	// 미들영역 디바이더
	$('.middle-area .js-tab-view').middleAreaDivider();
	
	var $leftArea = $('#tab-1 .pop-left-area');
	var $rightArea = $('#tab-1 .pop-right-area');
	var $tab1Width = $('#tab-1').width();
	$leftArea.resizable({
		handles: 'e',
		minWidth: 100,
		maxWidth: 450,
		resize:function(e, ui){
			var lw = $leftArea.width();
			var rw = $tab1Width - lw;
			$rightArea.css({
				width:rw,
				marginLeft:lw
			});
		}
	});
}


(function($){
	// 미들영역 디바이더
	$.fn.middleAreaDivider = function(opts){
		if(!this.length) return null;
		
		var settings = $.extend({
			type : true
		}, opts);
		
		return this.each(function(){
			
			var $this = $(this);

			// 디바이더 data 값들
			var dividerData = [
				{// 세로형 넓이값
					list_width : null,
					view_width : null
				},
				{// 가로형 높이값
					list_height : null,
					view_height : null
				}
			];

			// 핸들 있을경우 삭제
			if($this.find('.ui-resizable-handle').length > 0){
				$this.find('.ui-resizable-handle').remove();
			}
			
			// 분할할 영역이 2개일때만 호출
			if($this.find('.list-area').length > 0 && $this.find('.view-area').length > 0){
				if($this.parents('.content-area').hasClass('js-vertical')){ // 세로형
					layoutTypeVer();
				} else if($this.parents('.content-area').hasClass('js-horizontal')){ // 가로형
					layoutTypeHor();
				}
			}
			
			// 레이어타입 바꾸기
			$('.js-layout-change li').on('click' , function(){
				if($(this).index() > 2){
					return;
				}
				layoutChange($(this).index());
			});

			// 토글버튼 바인딩
			$this.find('.view-area .js-btn-dividerToggle').on('click' , function(){
				dividerToggle();

				if($(this).hasClass('v-up') || $(this).hasClass('v-down')){
					if($(this).hasClass('v-up')){
						$(this).removeClass('v-up').addClass('v-down');
					} else {
						$(this).removeClass('v-down').addClass('v-up');
					}

				} else if($(this).hasClass('h-up') || $(this).hasClass('h-down')){
					if($(this).hasClass('h-up')){
						$(this).removeClass('h-up').addClass('h-down');
					} else {
						$(this).removeClass('h-down').addClass('h-up');
					}
					
				}

			});

			function dividerToggle(){
				/* 디바이더 열고 닫기 */
				if($this.parents('.content-area').hasClass('js-vertical')){ // 세로형
					if($this.find('.list-area').resizable('instance') == undefined){
						layoutTypeVer();

					} else {
						$this.find('.list-area').resizable('destroy');
						$(window).off('resize.divider-per');
						$this.find('.list-area').hide();
						$this.find('.view-area').width('100%');
					}

				} else if($this.parents('.content-area').hasClass('js-horizontal')){ // 가로형
					if($this.find('.list-area').resizable('instance') == undefined){
						layoutTypeHor();
						
					} else {
						$this.find('.list-area').resizable('destroy');
						$(window).off('resize.divider-per');
						$this.find('.list-area').hide();
						$this.find('.view-area').height('100%');
					}
				}
			}

			function layoutChange(type){
				/* 디바이더 레이아웃 변경 */
				if(type == 0){ // 가로형
					if($this.parents('.content-area').hasClass('js-horizontal') && $this.find('.list-area').resizable('instance') != undefined){
						return;
					}
					$this.parents('.content-area').addClass('js-horizontal').removeClass('js-vertical');
					
					if($this.find('.list-area').resizable('instance') != undefined){
						$this.find('.list-area').resizable('destroy');
						$(window).off('resize.divider-per');
					}
					layoutTypeHor();

				} else if(type == 1){ // 세로형
					if($this.parents('.content-area').hasClass('js-vertical') && $this.find('.list-area').resizable('instance') != undefined){
						return;
					}
					$this.parents('.content-area').addClass('js-vertical').removeClass('js-horizontal');

					if($this.find('.list-area').resizable('instance') != undefined){
						$this.find('.list-area').resizable('destroy');
						$(window).off('resize.divider-per');
					}
					layoutTypeVer();
					
				} else if(type == 2){ // 목록형
					if(!$this.parents('.content-area').hasClass('js-vertical') && !$this.parents('.content-area').hasClass('js-horizontal')){
						return
					}
					$this.parents('.content-area').removeClass('js-vertical').removeClass('js-horizontal');

					if($this.find('.list-area').resizable('instance') != undefined){
						$this.find('.list-area').resizable('destroy');
						$(window).off('resize.divider-per');
					}
					
					$this.parents('.middle-area').find('.list-area').css({
						'display' : 'block',
						'width' : '100%',
						'height' : '100%'
					});
					
				}

				// 테이블 스크롤 체크가 필요할때
				if($this.find('.js-tbl-scrollChk').length > 0){
					$(window).trigger('resize.tblScrollChk');
				}
			}

			function layoutTypeVer(){
				// 세로형
				$this.find('.list-area').removeAttr('style').css({
					'float' : 'left',
					'width' : dividerData[0].list_width || '50%',
					'height' : '100%'
				});
				$this.find('.view-area').removeAttr('style').css({
					'float' : 'left',
					'width' : dividerData[0].view_width || '50%',
					'height' : '100%'
				});
				
				// 디바이더
				$this.find('.list-area').resizable({
					handles: 'e',
					minWidth: Math.floor($this.parents('.middle-area').width() * 33 / 100),
					maxWidth: Math.floor($this.parents('.middle-area').width() * 66 / 100),
					resize: function(e, ui){
						var parent = ui.element.parent();
						var remainingSpace = parent.width() - ui.element.outerWidth();
						
						ui.element.width(ui.element.width()/parent.width()*100+'%');

						var divTwo = ui.element.next(),
						divTwoWidth = (remainingSpace - (divTwo.outerWidth() - divTwo.width()))/parent.width()*100+'%';
						divTwo.width(divTwoWidth);
					},
					stop: function(e, ui){
						var parent = ui.element.parent();
						var remainingSpace = parent.width() - ui.element.outerWidth();
						
						uiWidth = ui.element.width()/parent.width()*100+'%';
						ui.element.width(uiWidth);
						
						var divTwo = ui.element.next(),
						divTwoWidth = (remainingSpace - (divTwo.outerWidth() - divTwo.width()))/parent.width()*100+'%';
						
						// 변수에 넓이값 담기
						dividerData[0].list_width = uiWidth;
						dividerData[0].view_width = divTwoWidth;
					}
				});
				
				// 리사이즈시 퍼센트기준으로 최소 최대 설정
				var middle_area = $this.parents('.middle-area'),
					list_area = $this.find('.list-area');
				$(window).on('resize.divider-per', function(){
					var minW = Math.floor(middle_area.width() * 33 / 100);
					var maxW = Math.floor(middle_area.width() * 66 / 100);
					list_area.resizable('option', { minWidth: minW , maxWidth: maxW });
				});
			}

			function layoutTypeHor(){
				// 가로형
				$this.find('.list-area').removeAttr('style').css({
					'float' : 'none',
					'width' : '100%',
					'height' : dividerData[1].list_height || '50%'
				});
				$this.find('.view-area').removeAttr('style').css({
					'float' : 'none',
					'width' : '100%',
					'height' : dividerData[1].view_height || '50%'
				});
				
				// 디바이더
				$this.find('.list-area').resizable({
					handles: 's',
					minHeight: Math.floor($this.parents('.middle-area').height() * 33 / 100),
					maxHeight: Math.floor($this.parents('.middle-area').height() * 66 / 100),
					resize: function(e, ui){
						var parent = ui.element.parent();
						var remainingSpace = parent.height() - ui.element.outerHeight();
						
						ui.element.height(ui.element.height()/parent.height()*100+'%');

						var divTwo = ui.element.next(),
						divTwoHeight = (remainingSpace - (divTwo.outerHeight() - divTwo.height()))/parent.height()*100+'%';
						divTwo.height(divTwoHeight);
						
					},
					stop: function(e, ui){
						var parent = ui.element.parent();
						var remainingSpace = parent.height() - ui.element.outerHeight();
						
						uiHeight = ui.element.height()/parent.height()*100+'%';
						ui.element.height(uiHeight);
						
						var divTwo = ui.element.next(),
						divTwoHeight = (remainingSpace - (divTwo.outerHeight() - divTwo.height()))/parent.height()*100+'%';

						// 변수에 높이값 담기
						dividerData[1].list_height = uiHeight;
						dividerData[1].view_height = divTwoHeight;
					}
				});

				// 리사이즈시 퍼센트기준으로 최소 최대 설정
				var middle_area = $this.parents('.middle-area'),
					list_area = $this.find('.list-area');
				$(window).on('resize.divider-per', function(){
					var minH = Math.floor(middle_area.height() * 33 / 100);
					var maxH = Math.floor(middle_area.height() * 66 / 100);
					list_area.resizable('option', { minHeight: minH , maxHeight: maxH });
				});
			}

		});
	};
	
})(jQuery);


(function($){
	// 테이블 스크롤 체크
	$.fn.tblScrollChk = function(opts){
		if(!this.length) return null;

		var settings = $.extend({
			type : null,
			height : '339'
		}, opts);
		
		return this.each(function(){

			var $tblEl = $(this),
				$listArea = $tblEl.parents('.list-area'),
				$viewArea = $tblEl.parents('.view-area'),
				$contHeader = $tblEl.parent().find('.cont-header'),
				$tblHead = $tblEl.find('.tbl-list-head'),
				$tblBody = $tblEl.find('.tbl-list-body'),
				$otherTop = $contHeader.prev(),
				$tblPaginate = $tblEl.parent().find('.paging-area');
			var scrollBarWidth = scrollbarWidth();
			var tblBodyHeight;
			
			function setScroll(){				
				var minusHeight = 0;				
				$tblEl.siblings().each(function(){
					if($(this).css('position') != 'absolute'){
						minusHeight += $(this).outerHeight(true);
					}
				});

				if(settings.type == 'popup'){
					tblBodyHeight = settings.height;
					$tblBody.css('max-height' , tblBodyHeight);
				} else {
					if($listArea.length){
						tblBodyHeight = $listArea.outerHeight() - $contHeader.outerHeight() - $otherTop.outerHeight() - $tblPaginate.outerHeight() - $tblHead.outerHeight()  - ( $tblBody.outerHeight() - $tblBody.height()) ;
						$tblBody.height(tblBodyHeight);
						
					} else if($viewArea.length){
						tblBodyHeight = $viewArea.outerHeight() - $contHeader.outerHeight() - $otherTop.outerHeight() - $tblPaginate.outerHeight() - $tblHead.outerHeight()  - ( $tblBody.outerHeight() - $tblBody.height()) ;
						$tblBody.height(tblBodyHeight);
						
						if($tblEl.parents('.view-content').length > 0){
							$tblEl.parents('.view-content').css('overflow-y' , 'hidden');
						}
					
					} else {
						$tblBody.height('auto');
					}
				}
				
				//no-data
				if($tblEl.find('.no-data').length > 0){
					$tblBody.find('table').eq(0).height(tblBodyHeight);
				} else {
					$tblBody.find('table').eq(0).height('auto');
				}
				
				var scrollBarChk = $tblBody.width() - $tblBody.find('table').eq(0).width();				
				if(scrollBarChk <= 1){
					$tblHead.css('padding-right', '0');
				} else {
					$tblHead.css('padding-right', scrollBarWidth);
				}

				if($tblBody.find('.contacts-index').length > 0){
					$tblBody.find('.contacts-index').height($tblBody.find('table').eq(0).height()).css('min-height' , '100%');
				}

			}
			setScroll();
			$(window).on('resize.tblScrollChk' , function(){
				setScroll();				
			});

			function scrollbarWidth(){
				var $inner = jQuery('<div style="width: 100%; height:200px;">test</div>'),
					$outer = jQuery('<div style="width:200px;height:150px; position: absolute; top: 0; left: 0; visibility: hidden; overflow:hidden;"></div>').append($inner),
					inner = $inner[0],
					outer = $outer[0];

				jQuery('body').append(outer);
				var width1 = inner.offsetWidth;
				$outer.css('overflow', 'scroll');
				var width2 = outer.clientWidth;
				$outer.remove();
				
				return (width1 - width2);
			}
		});
	};
})(jQuery);


function tabInit(){
	if($('.tab-st01').length <= 0){
		return;
	}
	var tabObj = $('.tab-st01');
	var chk = true;
	var more_tab = tabObj.find('.more-tab');
	var more_tab_layer = $('.tab-list-more');
	more_tab.hide();
	more_tab_layer.hide();
	
	// 탭추가 클릭시
	$('.new-tab').on('click' , function(){
		tabObj.find('.current').removeClass('current');
		more_tab_layer.find('.current').removeClass('current');
		
		// 탭추가
		if(chk){
			more_tab.before('<li class="current"><a href="#">탭탭탭' +tabObj.find('> li').length+ '</a><button type="button" class="button-img del"><span>삭제</span></button></li>');
			more_tab.hide();
		} else {
			more_tab_layer.find('ul').append('<li class="current"><a href="#">탭탭탭'+(tabObj.find('> li').length + more_tab_layer.find('ul > li').length)+'</a><button type="button" class="button-img del"><span>삭제</span></button></li>');
			more_tab.addClass('current').show();
		}
		
		// 레이어 위치조정
		more_tab_layer.css({
			//'top' : tabObj.offset().top + tabObj.height(),
			'left' : tabObj.find('> li:visible').eq(-1).position().left - (more_tab_layer.width() - tabObj.find('> li:visible').eq(-1).width())
		});

		// 추가 가능한지 체크
		if(tabObj.width() < tabObj.find('> li').length * tabObj.find('> li').eq(0).width() + more_tab.width()){
			chk = false;
		} else {
			chk = true;
		}

	});
	
	// 탭 클릭시
	tabObj.on('click' , '> li > a' , function(){
		
		$(this).parent('li').addClass('current').siblings().removeClass('current');
		if($(this).parent('li').hasClass('more-tab')){
			more_tab_layer.show();
			return;
		} else {
			more_tab_layer.find('.current').removeClass('current');
			more_tab_layer.hide();
		}
		
		// 테이블 스크롤 체크가 필요할때
		if($('.js-tbl-scrollChk').length > 0){
			$(window).trigger('resize.tblScrollChk');
		}
	});
	
	// 레이어 탭 클릭시
	more_tab_layer.on('click' , 'a' , function(){
		tabObj.find('.current').removeClass('current');
		more_tab.addClass('current')
		$(this).parent('li').addClass('current').siblings().removeClass('current');
		
		/// 테이블 스크롤 체크가 필요할때
		if($('.js-tbl-scrollChk').length > 0){
			$(window).trigger('resize.tblScrollChk');
		}
	});

	// 탭 삭제
	tabObj.on('click' , '.del' , function(){
		// 현재 current 인걸 삭제시 맨처음탭 활성화
		if($(this).parents('li').hasClass('current')){
			tabObj.find('> li').eq(0).addClass('current');
		}
		
		// 탭 + 탭내용 삭제
		$(this).parents('li').remove();
		
		if(more_tab_layer.find('ul > li').length > 0){
			more_tab.before(more_tab_layer.find('ul > li').eq(0));
		}
		if(more_tab_layer.find('ul > li').length == 0){
			more_tab.hide();
		}

		// 추가 가능한지 체크
		if(tabObj.width() < tabObj.find('> li').length * tabObj.find('> li').eq(0).width() + more_tab.width()){
			chk = false;
		} else {
			chk = true;
		}
	});
	
	// 탭 레이어에서 삭제
	more_tab_layer.on('click' , '.del' , function(){
		// 현재 current 인걸 삭제시 맨처음탭 활성화
		if($(this).parents('li').hasClass('current')){
			tabObj.find('> li').eq(0).addClass('current');
			more_tab.removeClass('current');
			more_tab_layer.hide();
		}
		
		$(this).parents('li').remove();
		
		if(more_tab_layer.find('ul > li').length == 0){
			more_tab.hide();
			more_tab_layer.hide();
		}

	});
	
	// 리사이즈
	$(window).on('resize.tabChk' , function(){
		var sum = 0;
		var tabNum = 0;
		for(var i=0; i<tabObj.find('> li').length; i++){
			sum += tabObj.find('> li').eq(i).width();
		}

		if(tabObj.width() < sum){
			// 탭의 넓이합이 클때
			tabNum = parseInt((sum - tabObj.width()) / tabObj.find('> li').eq(0).width());
			for(var i=0; i<tabNum+1; i++){
				more_tab_layer.find('ul').prepend(more_tab.prev());
			}
			more_tab.show();
		} else if(tabObj.width() > sum + (tabObj.find('> li').eq(0).width()) ){
			// 탭의 넓이합이 작을때 (모어버튼 + 버튼한개의 넓이 포함)
			if(more_tab_layer.find('ul > li').length == 0){
				return;
			}
			tabNum = parseInt((tabObj.width() - sum) / tabObj.find('> li').eq(0).width());
			for(var i=0; i<tabNum; i++){
				more_tab.before(more_tab_layer.find('ul > li').eq(0));
			}
			if(more_tab_layer.find('ul > li').length == 0){
				more_tab.hide();
				more_tab_layer.hide();
			}
		}

		// 레이어 위치조정
		if(more_tab_layer.length > 0){
			more_tab_layer.css({
				//'top' : tabObj.offset().top + tabObj.height(),
				'left' : tabObj.find('> li:visible').eq(-1).position().left - (more_tab_layer.width() - tabObj.find('> li:visible').eq(-1).width())
			});
		}

		// 추가 가능한지 체크
		if(tabObj.width() < tabObj.find('> li').length * tabObj.find('> li').eq(0).width() + more_tab.width()){
			chk = false;
		} else {
			chk = true;
		}
	});

}

(function($){
	// 트리구조
	$.fn.treeSet = function(opts){
		if(!this.length) return null;

		return this.each(function(){
			
			var $this = $(this);
			var objCls = $(this).attr('class');
			objCls = objCls.split(' ');
			objCls = objCls.join('.');
			
			// 세팅
			$this.addClass('js-sub-tree');
			$this.find('ul').addClass('js-sub-list').hide();
			$this.find('.open').removeClass('open');
			$this.find('.current').removeClass('current');
			$this.find('.item-more').removeClass('item-more');
			$this.find('li:has(ul)').each(function(){
				$(this).find('> span').addClass('item-more');
			});
			$this.find('span').each(function(){
				var len = $(this).parents('.js-sub-list').length;
				$(this).find('em').css('margin-left' , len * 18 + 'px');
			});
			
			function showToggle(obj){
				var $obj = obj;
				if($obj.parent('span').hasClass('open')){
					$obj.parent('span').removeClass('open');
					$obj.parent('span').next('ul').hide();
				} else {
					$obj.parent('span').addClass('open');
					$obj.parent('span').next('ul').show();
				}
			}

			// 블릿 클릭
			$this.find('.item-more em').bind('click' , function(){
				showToggle($(this));
			});

			// 텍스트 클릭
			$this.find('span > a').bind('click' , function(e){
				e.preventDefault();
				showToggle($(this));
				$this.find('.current').removeClass('current');
				$(this).parent('span').addClass('current');
				
			});
		});
	};
})(jQuery);


(function($){
	// 서브 셀렉트메뉴
	$.fn.subSelect = function(opts){
		if(!this.length) return null;
		
		var settings = $.extend({
			type : 'a'
		}, opts);

		return this.each(function(){
			var $this = $(this);
			var $select;
			var type = settings.type;
			if($this.hasClass('select02')){
				type = 'a'; // 팝업에 들어가는 서브 셀렉트박스
			} else {
				type = 'b'; // 레이어에 들어가는 서브 레이어메뉴
			}

			$this.addClass('js-sub-select');
			// a 타입일때 ( 검색 상세 )
			if(type == 'a'){
				$this.find('> ul').addClass('js-select-list');
				$this.find('> button').on('click' ,  function(e){
					//e.stopPropagation();
					
					if($this.hasClass('disabled')) return;
					
					if($(this).parent().find('> ul').is(':visible')){
						$(this).parent().find('> ul').hide();
						$(this).parent().find('> button').focus();
						$(document).unbind('click.subSelect');
					} else {
						$('.js-select-list').hide();
						$(this).parent().find('> ul').show();
						$(document).bind('click.subSelect' , function(e){
							if (!$this.find('.layer-list').is(e.target) && $this.find('.layer-list').has(e.target).length === 0
								&& $this.find('.layer-list').is(':visible')
								&& !$this.find('> button').is(e.target) && $this.find('> button').has(e.target).length === 0){
								$this.find('.layer-list').hide();
								$this.find('> button').focus();
								
								$(document).unbind('click.subSelect');
							}
						});
					}
				});
				
				$this.find('.layer-list').on('click','li a' , function(e){
					//e.stopPropagation();
					
					$(this).closest('.js-sub-select').find('.current').removeClass('current');
					$(this).parent().addClass('current').siblings().removeClass('current');
					$(this).parents('ul.layer-list').hide();
					$(this).parents('ul.layer-list').prev().focus();
					// text값 변경 (contents().filter() 로 가져올지 고민)
					if($this.find('> button .cate-select').length > 0){
						var boxColor = $(this).find('span').eq(1).css('background-color');
						$(this).parents('ul.layer-list').prev().find('.sch-value .cate-select').css('background-color' , boxColor);
						$(this).parents('ul.layer-list').prev().find('.sch-value span:not(.cate-select)').text($(this).text());
					} else {
						$(this).parents('ul.layer-list').prev().find('.sch-value').text($(this).text());
					}
					$(this).parents('ul.layer-list').prev().find('.sch-value').attr('title' , $(this).text());
					if($(this).text() == '직접입력'){
						$(this).parents('.select02').next('.day-term').show();
					} else {
						$(this).parents('.select02').next('.day-term').hide();
					}
					$(document).unbind('click.subSelect');

					return false;
				});

			}

			// b 타입일때 ( 우클릭 레이어 )
			if(type == 'b'){
				$this.next().addClass('js-select-list');
				$this.on('click' , function(e){
					//e.stopPropagation();
					if($(this).next('.ly-sub-box').is(':visible')){
						$(this).next('.ly-sub-box').hide();
						$(document).unbind('click.subSelect');
					} else {
						$('.js-select-list').hide();
						$(this).next('.ly-sub-box').show();
						$(document).bind('click.subSelect' , function(e){
							if (!$this.next('.ly-sub-box').is(e.target) && $this.next('.ly-sub-box').has(e.target).length === 0
								&& $this.next('.ly-sub-box').is(':visible')
								&& !$this.is(e.target) && $this.has(e.target).length === 0){
								$this.next('.ly-sub-box').hide();
								$this.focus();
								$(document).unbind('click.subSelect');
							}
						});
					}
				});
				$this.next('.ly-sub-box').on('click', 'li', function(){
					var currentObj = $(this).find('a').text()+'<i>레이어열기</i>';
					$(this).parents('.ly-sub-box').prev().find('span').html(currentObj);
					$(this).parents('.ly-sub-box').hide();
					$(this).parents('.ly-sub-box').prev().focus();
					$(document).unbind('click.subSelect');
					return false;
				});
			}
		});
	};
})(jQuery);



$(document).ready(function(){
	layoutInit(); // 레이아웃 설정
	//tabInit(); // 탭 설정

	$('.js-tbl-scrollChk').tblScrollChk(); // 테이블 스크롤 체크
	$('.js-tbl-scrollChk-popup').tblScrollChk({ // 테이블 스크롤 체크 (팝업)
		type : 'popup',
		height : 340
	});
	$('.tree-st01').treeSet(); // 트리구조
	$('.tree-st02').treeSet(); // 트리구조
	$('.select02').subSelect(); // 셀렉트 메뉴 (순감검색 상세 레이어)
	$('.select-sub01').subSelect(); // 셀렉트 메뉴 (우클릭 레이어)
});